import React from 'react';
import ModalConsumer from './ModalConsumer';

var ModalRoot = function ModalRoot() {
  return /*#__PURE__*/React.createElement(ModalConsumer, null, function (_ref) {
    var Component = _ref.component,
        isOpen = _ref.isOpen,
        modalProps = _ref.modalProps,
        removeModal = _ref.removeModal,
        hideModal = _ref.hideModal,
        showModal = _ref.showModal;
    var renderComponent = Component ? /*#__PURE__*/React.createElement(Component, Object.assign({}, modalProps, {
      onDismiss: removeModal,
      isOpen: isOpen,
      onRequestClose: hideModal,
      showModal: showModal
    })) : null;
    return renderComponent;
  });
};

export default ModalRoot;